jQuery(document).ready(function () {
    getJson();
    filterDrop();
});

function filterDrop() {
    jQuery('.drop-box').click(function (event) {
        event.stopPropagation();
        jQuery(this).parents('.filter-box').siblings('.filter-box').find('ul').removeClass('ul-show');
        jQuery(this).find('ul').toggleClass('ul-show');
    });

    jQuery('body').click(function () {
        jQuery('.drop-box').find('ul').removeClass('ul-show');
    });
}

function getJson() {
    var jsondata = {};
    var json_url = '/api/fixtures.php';

    jQuery.getJSON(json_url, function (data, status) {

        if (status == 'success') {
            jsondata = data;

            var isFixtures = window.location.pathname === '/' ? true : false;
            var resultsShouldNotDisplay = [];

            for (var i = 0; i < jsondata.length; i++) {
                if (resultsShouldNotDisplay.includes(jsondata[i].draw_status.toLowerCase().trim())) {
                    jsondata.splice(i, 1);
                    i -= 1;
                }
            }

            var url = window.location.search;
            var theRequest = new Object();
            if (url.indexOf('?') != -1) {
                var str = url.substr(1);
                str = str.substring(str.indexOf('?') + 1);
                var strs = str.split('@');
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1]);
                }
            }

            var venueArr = [];
            for (var i in jsondata) {
                var venue = jsondata[i].venue;
                if (jQuery.inArray(venue, venueArr) < 0) {
                    venueArr.push(venue);
                }
            }

            var gradeArr = [];
            for (var i in jsondata) {
                var grade = jsondata[i].grade.replace(/\s/g, '');
                if (jQuery.inArray(grade, gradeArr) < 0) {
                    gradeArr.push(grade);
                }
            }

            var baseRoundArr = [];
            var roundArr = [];
            for (var i in jsondata) {
                var round = jsondata[i].group_date;
                if (round == 'Trial ' || round == 'Trial') {
                    round = 'Trial';
                }
                if (jQuery.inArray(round, baseRoundArr) < 0) {
                    baseRoundArr.push(round);
                    roundArr.push([round, jsondata[i].date]);
                }
            }

            baseRoundArr.sort(function (x, y) {
                return moment(x, 'DD/MM/YYYY').unix() - moment(y, 'DD/MM/YYYY').unix();
            });

            var sportArr = [];
            for (var i in jsondata) {
                var sport = jsondata[i].sport;
                if (jQuery.inArray(sport, sportArr) < 0) {
                    sportArr.push(sport);
                }
            }

            var teamArr = [];
            for (var i in jsondata) {
                var team = jsondata[i].team;
                if (jQuery.inArray(team, teamArr) < 0) {
                    teamArr.push(team);
                }
            }

            // Build campus (grade) filter options
            for (var i in gradeArr) {
                var count = 0;
                var sportInArr = [];
                var roundInArr = [];
                var teamInArr = [];

                for (var j in jsondata) {
                    var grade = jsondata[j].grade.replace(/\s/g, '');
                    var round = jsondata[j].group_date;
                    var sport = jsondata[j].sport;
                    var team  = jsondata[j].team;

                    if (round == 'Trial ' || round == 'Trial') round = 'Trial';

                    if (grade == gradeArr[i]) {
                        count++;
                        if (jQuery.inArray(sport, sportInArr) < 0) sportInArr.push(sport);
                        if (jQuery.inArray(team, teamInArr) < 0) teamInArr.push(team);
                        if (jQuery.inArray(round, roundInArr) < 0) roundInArr.push(round);
                    }
                }
                jQuery('.campus-select ul').append(
                    '<li data-round="' + roundInArr + '" data-sport="' + sportInArr + '" data-team="' + teamInArr + '">' +
                    '<button data-grade="' + gradeArr[i] + '">' + gradeArr[i] + ' (' + count + ')</button></li>'
                );
            }

            // Build date (round) filter options
            for (var i in baseRoundArr) {
                var count = 0;
                var gradeInArr = [];
                var sportInArr = [];
                var teamInArr  = [];

                for (var j in jsondata) {
                    var grade = jsondata[j].grade.replace(/\s/g, '');
                    var round = jsondata[j].group_date;
                    var sport = jsondata[j].sport;
                    var team  = jsondata[j].team;

                    if (round == 'Trial ' || round == 'Trial') round = 'Trial';

                    if (round == baseRoundArr[i]) {
                        count++;
                        if (jQuery.inArray(grade, gradeInArr) < 0) gradeInArr.push(grade);
                        if (jQuery.inArray(sport, sportInArr) < 0) sportInArr.push(sport);
                        if (jQuery.inArray(team, teamInArr) < 0) teamInArr.push(team);
                    }
                }
                jQuery('.round-select ul').append(
                    '<li data-grade="' + gradeInArr + '" data-sport="' + sportInArr + '" data-team="' + teamInArr + '">' +
                    '<button data-round="' + baseRoundArr[i] + '">' +
                    moment(baseRoundArr[i], 'DD/MM/YYYY').format('dddd D MMMM YYYY') + ' (' + count + ')</button></li>'
                );
            }

            // Build sport filter options
            for (var i in sportArr) {
                var count = 0;
                var gradeInArr = [];
                var roundInArr = [];
                var teamInArr  = [];

                for (var j in jsondata) {
                    var grade = jsondata[j].grade.replace(/\s/g, '');
                    var round = jsondata[j].group_date;
                    var sport = jsondata[j].sport;
                    var team  = jsondata[j].team;

                    if (round == 'Trial ' || round == 'Trial') round = 'Trial';

                    if (sport == sportArr[i]) {
                        count++;
                        if (jQuery.inArray(grade, gradeInArr) < 0) gradeInArr.push(grade);
                        if (jQuery.inArray(team, teamInArr) < 0) teamInArr.push(team);
                        if (jQuery.inArray(round, roundInArr) < 0) roundInArr.push(round);
                    }
                }
                jQuery('.sport-select ul').append(
                    '<li data-grade="' + gradeInArr + '" data-round="' + roundInArr + '" data-team="' + teamInArr + '">' +
                    '<button data-sport="' + sportArr[i] + '">' + sportArr[i] + ' (' + count + ')</button></li>'
                );
            }

            // Build team filter options
            for (var i in teamArr) {
                var count = 0;
                var gradeInArr = [];
                var sportInArr = [];
                var roundInArr = [];

                for (var j in jsondata) {
                    var grade = jsondata[j].grade.replace(/\s/g, '');
                    var round = jsondata[j].group_date;
                    var sport = jsondata[j].sport;
                    var team  = jsondata[j].team;

                    if (round == 'Trial ' || round == 'Trial') round = 'Trial';

                    if (team == teamArr[i]) {
                        count++;
                        if (jQuery.inArray(grade, gradeInArr) < 0) gradeInArr.push(grade);
                        if (jQuery.inArray(sport, sportInArr) < 0) sportInArr.push(sport);
                        if (jQuery.inArray(round, roundInArr) < 0) roundInArr.push(round);
                    }
                }
                jQuery('.team-select ul').append(
                    '<li data-grade="' + gradeInArr + '" data-round="' + roundInArr + '" data-sport="' + sportInArr + '">' +
                    '<button data-team="' + teamArr[i] + '">' + teamArr[i] + ' (' + count + ')</button></li>'
                );
            }

            // Build date-grouped rows
            for (var i in baseRoundArr) {
                var roundDate  = [];
                var roundMin   = baseRoundArr[i];

                for (var j in jsondata) {
                    var round = jsondata[j].group_date;
                    var date  = jsondata[j].date;
                    if (round == 'Trial ' || round == 'Trial') round = 'Trial';

                    if (round == baseRoundArr[i]) {
                        var stringTime = date;
                        if (stringTime.charAt(2) == '/') {
                            stringTime = stringTime.substring(6, 10) + '-' + stringTime.substring(3, 5) + '-' + stringTime.substring(0, 2);
                        }
                        roundDate.push(Date.parse(new Date(stringTime)) / 1000);
                    }
                }

                var min      = Math.min.apply(null, roundDate);
                var mindate  = new Date(min * 1000);
                var minD     = (mindate.getDate() < 10 ? '0' : '') + mindate.getDate();
                var minM     = (mindate.getMonth() + 1 < 10 ? '0' : '') + (mindate.getMonth() + 1);
                var minY     = mindate.getFullYear();
                roundMin     = minD + '/' + minM + '/' + minY;

                var formatted       = moment(roundMin, 'DD/MM/YYYY').format('ddd D MMMM YYYY');
                var formattedMobile = formatted;

                jQuery('.data-table').append(
                    '<div class="round-row" data-round="' + baseRoundArr[i] + '">' +
                    '<div class="round-title">' +
                    '<span class="widescreen">' + formatted + '</span>' +
                    '<span class="mobile">' + formattedMobile + '</span>' +
                    '</div></div>'
                );
            }

            // Add sport rows inside each date row
            for (var i in sportArr) {
                jQuery('.round-row').append(
                    '<div class="sport-row" data-sport="' + sportArr[i] + '">' +
                    '<div class="sport-title">' + sportArr[i] + '</div>' +
                    '<div class="table-wrap"><table>' +
                    '<thead><tr>' +
                    '<th>Date</th><th>Start Time</th><th>Team</th><th>Opponent</th>' +
                    '<th>Location</th><th>Address</th><th>Venue</th><th>Draw Status</th>' +
                    '</tr></thead><tbody></tbody></table></div></div>'
                );
            }

            // Populate table rows
            jQuery('.sport-row table tbody').each(function () {
                var wrap       = jQuery(this);
                var tableRound = wrap.parents('.round-row').attr('data-round');
                var tableSport = wrap.parents('.sport-row').attr('data-sport');

                for (var i in jsondata) {
                    var round = jsondata[i].group_date;
                    var sport = jsondata[i].sport;
                    if (round == 'Trial ' || round == 'Trial') round = 'Trial';

                    if (round == tableRound && sport == tableSport) {
                        var grade      = jsondata[i].grade.replace(/\s/g, '');
                        var drawStatus = jsondata[i].draw_status;

                        if (!['unconfirmed', 'confirmed', 'cancelled'].includes(drawStatus.toLowerCase())) {
                            drawStatus = '';
                        }

                        var addressLink = jsondata[i].address
                            ? '<a target="_blank" href="https://maps.google.com.au/?q=' + encodeURIComponent(jsondata[i].address) + '">' + jsondata[i].address + '</a>'
                            : '';
                        var subLocLink = jsondata[i].subLocation
                            ? '<br><a target="_blank" href="https://maps.google.com.au/?q=' + encodeURIComponent(jsondata[i].subLocation) + '">' + jsondata[i].subLocation + '</a>'
                            : '';

                        wrap.append(
                            '<tr class="data-row" data-grade="' + grade + '" data-team="' + jsondata[i].team + '">' +
                            '<td>' + jsondata[i].date + '</td>' +
                            '<td>' + jsondata[i].start + '</td>' +
                            '<td>' + jsondata[i].team + '</td>' +
                            '<td>' + jsondata[i].opponent + '</td>' +
                            '<td>' + jsondata[i].location + '</td>' +
                            '<td>' + addressLink + subLocLink + '</td>' +
                            '<td>' + jsondata[i].venue + '</td>' +
                            '<td>' + drawStatus + '</td>' +
                            '</tr>'
                        );
                    }
                }

                if (wrap.find('tr').length == 0) {
                    wrap.parents('.sport-row').remove();
                }
            });

            // ---- Filter interaction ----

            var addGradeFilter = [];
                var addRoundFilter = [];
                var addSportFilter = [];
                var addTeamFilter  = [];

            jQuery('.filter-box ul li button').click(function (event) {
                event.stopPropagation();
                jQuery(this).parents('ul').removeClass('ul-show');

                if (jQuery(this).parent('li').hasClass('selected')) return;
                jQuery(this).parent('li').addClass('selected');

                var html = jQuery(this).html();

                if (jQuery(this).parents('.filter-box').hasClass('campus-select')) {
                    var grade = jQuery(this).attr('data-grade');
                    jQuery(this).parents('.filter-box').find('.selected-box').append(
                        '<div data-grade="' + grade + '" class="remove-selected"><button></button>' + html + '</div>'
                    );
                    addGradeFilter.push(grade);
                    updateFilterVisibility('grade', addGradeFilter);
                    applyGradeFilter(addGradeFilter);
                }

                if (jQuery(this).parents('.filter-box').hasClass('round-select')) {
                    var round = jQuery(this).attr('data-round');
                    jQuery(this).parents('.filter-box').find('.selected-box').append(
                        '<div data-round="' + round + '" class="remove-selected"><button></button>' + html + '</div>'
                    );
                    addRoundFilter.push(round);
                    updateFilterVisibility('round', addRoundFilter);
                    applyRoundFilter(addRoundFilter);
                }

                if (jQuery(this).parents('.filter-box').hasClass('sport-select')) {
                    var sport = jQuery(this).attr('data-sport');
                    jQuery(this).parents('.filter-box').find('.selected-box').append(
                        '<div data-sport="' + sport + '" class="remove-selected"><button></button>' + html + '</div>'
                    );
                    addSportFilter.push(sport);
                    updateFilterVisibility('sport', addSportFilter);
                    applySportFilter(addSportFilter);
                }

                if (jQuery(this).parents('.filter-box').hasClass('team-select')) {
                    var team = jQuery(this).attr('data-team');
                    jQuery(this).parents('.filter-box').find('.selected-box').append(
                        '<div data-team="' + team + '" class="remove-selected"><button></button>' + html + '</div>'
                    );
                    addTeamFilter.push(team);
                    updateFilterVisibility('team', addTeamFilter);
                    applyTeamFilter(addTeamFilter);
                }

                updateEmptyStates();
                updateDropboxAbility();
            });

            jQuery('.filter-box').on('click', '.selected-box .remove-selected button', function () {
                var box = jQuery(this).parents('.filter-box');

                if (box.hasClass('campus-select')) {
                    var grade = jQuery(this).parent().attr('data-grade');
                    jQuery('.campus-select ul li').each(function () {
                        if (jQuery(this).find('button').attr('data-grade') == grade) jQuery(this).removeClass('selected');
                    });
                    addGradeFilter.splice(jQuery.inArray(grade, addGradeFilter), 1);
                    if (addGradeFilter.length) {
                        updateFilterVisibility('grade', addGradeFilter);
                        applyGradeFilter(addGradeFilter);
                    } else {
                        clearFilterVisibility('grade');
                        jQuery('.data-row').removeClass('campus-filter-hide');
                    }
                }

                if (box.hasClass('round-select')) {
                    var round = jQuery(this).parent().attr('data-round');
                    jQuery('.round-select ul li').each(function () {
                        if (jQuery(this).find('button').attr('data-round') == round) jQuery(this).removeClass('selected');
                    });
                    addRoundFilter.splice(jQuery.inArray(round, addRoundFilter), 1);
                    if (addRoundFilter.length) {
                        updateFilterVisibility('round', addRoundFilter);
                        applyRoundFilter(addRoundFilter);
                    } else {
                        clearFilterVisibility('round');
                        jQuery('.round-row').removeClass('filter-hide');
                    }
                }

                if (box.hasClass('sport-select')) {
                    var sport = jQuery(this).parent().attr('data-sport');
                    jQuery('.sport-select ul li').each(function () {
                        if (jQuery(this).find('button').attr('data-sport') == sport) jQuery(this).removeClass('selected');
                    });
                    addSportFilter.splice(jQuery.inArray(sport, addSportFilter), 1);
                    if (addSportFilter.length) {
                        updateFilterVisibility('sport', addSportFilter);
                        applySportFilter(addSportFilter);
                    } else {
                        clearFilterVisibility('sport');
                        jQuery('.sport-row').removeClass('filter-hide');
                    }
                }

                if (box.hasClass('team-select')) {
                    var team = jQuery(this).parent().attr('data-team');
                    jQuery('.team-select ul li').each(function () {
                        if (jQuery(this).find('button').attr('data-team') == team) jQuery(this).removeClass('selected');
                    });
                    addTeamFilter.splice(jQuery.inArray(team, addTeamFilter), 1);
                    if (addTeamFilter.length) {
                        updateFilterVisibility('team', addTeamFilter);
                        applyTeamFilter(addTeamFilter);
                    } else {
                        clearFilterVisibility('team');
                        jQuery('.data-row').removeClass('team-filter-hide');
                    }
                }

                jQuery(this).parent().remove();
                updateEmptyStates();
                updateDropboxAbility();
            });

            // Apply URL query param pre-filters
            var campus = theRequest['campus'];
            var round  = theRequest['round'];
            var sport  = theRequest['sport'];
            var team   = theRequest['team'];

            if (campus) {
                campus.toLowerCase().split(',').forEach(function (val) {
                    jQuery('.campus-select ul li button').each(function () {
                        if (jQuery(this).attr('data-grade').toLowerCase() == val) jQuery(this).trigger('click');
                    });
                });
            }
            if (round) {
                round.split(',').forEach(function (val) {
                    jQuery('.round-select ul li button').each(function () {
                        if (jQuery(this).attr('data-round').toLowerCase() == val.toLowerCase()) jQuery(this).trigger('click');
                    });
                });
            }
            if (sport) {
                sport.split(',').forEach(function (val) {
                    jQuery('.sport-select ul li button').each(function () {
                        if (jQuery(this).attr('data-sport').toLowerCase() == val.toLowerCase()) jQuery(this).trigger('click');
                    });
                });
            }
            if (team) {
                team.split(',').forEach(function (val) {
                    jQuery('.team-select ul li button').each(function () {
                        if (jQuery(this).attr('data-team').toLowerCase() == val.toLowerCase()) jQuery(this).trigger('click');
                    });
                });
            }

            updateEmptyStates();
            updateDropboxAbility();
        }
    });
}

// ---- Filter helpers ----

function updateFilterVisibility(type, activeValues) {
    var attrMap = { grade: 'data-grade', round: 'data-round', sport: 'data-sport', team: 'data-team' };
    var classMap = { grade: 'c-unselect', round: 'r-unselect', sport: 's-unselect', team: 't-unselect' };
    var selectors = ['.campus-select ul li', '.round-select ul li', '.sport-select ul li', '.team-select ul li'];

    selectors.forEach(function (sel) {
        jQuery(sel).each(function () {
            var vals = (jQuery(this).attr(attrMap[type]) || '').split(',');
            var match = activeValues.some(function (v) { return vals.indexOf(v) >= 0; });
            jQuery(this).toggleClass(classMap[type], !match);
        });
    });
}

function clearFilterVisibility(type) {
    var classMap = { grade: 'c-unselect', round: 'r-unselect', sport: 's-unselect', team: 't-unselect' };
    jQuery('li').removeClass(classMap[type]);
}

function applyGradeFilter(activeGrades) {
    jQuery('.data-row').each(function () {
        var grade = jQuery(this).attr('data-grade');
        jQuery(this).toggleClass('campus-filter-hide', jQuery.inArray(grade, activeGrades) < 0);
    });
    restripeRows();
}

function applyRoundFilter(activeRounds) {
    jQuery('.round-row').each(function () {
        var round = jQuery(this).attr('data-round');
        jQuery(this).toggleClass('filter-hide', jQuery.inArray(round, activeRounds) < 0);
    });
    restripeRows();
}

function applySportFilter(activeSports) {
    jQuery('.sport-row').each(function () {
        var sport = jQuery(this).attr('data-sport');
        jQuery(this).toggleClass('filter-hide', jQuery.inArray(sport, activeSports) < 0);
    });
    restripeRows();
}

function applyTeamFilter(activeTeams) {
    jQuery('.data-row').each(function () {
        var team = jQuery(this).attr('data-team');
        jQuery(this).toggleClass('team-filter-hide', jQuery.inArray(team, activeTeams) < 0);
    });
    restripeRows();
}

function restripeRows() {
    jQuery('.sport-row').each(function () {
        jQuery(this).find('.data-row:not(.filter-hide)').each(function (i) {
            jQuery(this).toggleClass('bg-row', i % 2 == 0).toggleClass('white-row', i % 2 != 0);
        });
    });
}

function updateEmptyStates() {
    jQuery('.sport-row').each(function () {
        var total  = jQuery(this).find('.data-row').length;
        var hidden = jQuery(this).find('.data-row.team-filter-hide, .data-row.campus-filter-hide, .data-row.school-hide').length;
        // count rows hidden by all active filters combined
        var visible = jQuery(this).find('.data-row').not('.team-filter-hide').not('.campus-filter-hide').not('.school-hide').length;
        jQuery(this).toggleClass('no-child', visible == 0);
    });

    jQuery('.round-row').each(function () {
        var visible = jQuery(this).find('.sport-row').not('.filter-hide').not('.no-child').length;
        jQuery(this).toggleClass('no-child', visible == 0);
    });
}

function updateDropboxAbility() {
    jQuery('.filter-box ul').each(function () {
        var able = jQuery(this).find('li').not('.t-unselect, .c-unselect, .r-unselect, .s-unselect, .selected').length;
        jQuery(this).parent('.drop-box').toggleClass('unable', able == 0);
    });
}
